<app-menu>
  <div class="desktop">
    <app-voltar class="back" />
    <div class="header">
      <app-titulo
        [text]="!isEditing ? 'Diário de Obra' : 'Edição Diário de Obra'"
      ></app-titulo>
    </div>
    <form class="form">
      <app-input
        type="select"
        width="100%"
        label="Obra"
        name="ObraId"
        [selectData]="obrasOptions"
        [(ngModel)]="form.ObraId"
        (ngModelChange)="updateObra($event)"
        [requiredInput]="true"
        [disabled]="isEditing"
      ></app-input>
      <app-input
        type="text"
        width="100%"
        label="Endereço"
        name="TxEndereco"
        [(ngModel)]="form.TxEndereco"
        [disabled]="true"
      ></app-input>
      <app-input
        type="date"
        width="100%"
        placeholder="dd/mm/aaaa"
        label="Data de Início"
        name="DtInicio"
        [(ngModel)]="form.DtInicio"
        [disabled]="true"
      ></app-input>
      <app-input
        type="text"
        width="100%"
        label="Prazo (dias)"
        name="TxPrazoDias"
        [(ngModel)]="form.TxPrazoDias"
        [disabled]="true"
      ></app-input>
      <app-input
        type="select"
        width="100%"
        label="Responsável"
        name="FuncionarioResponsavelId"
        [(ngModel)]="form.FuncionarioResponsavelId"
        [selectData]="responsavelOptions"
        [requiredInput]="true"
        [disabled]="isEditing"
      ></app-input>
      <app-input
        type="date"
        width="100%"
        placeholder="dd/mm/aaaa"
        label="Data do diário"
        name="DtDiario"
        [(ngModel)]="form.DtDiario"
        [requiredInput]="true"
        [disabled]="true"
      ></app-input>
      <app-input
        type="textarea"
        width="100%"
        class="grid-2fr"
        placeholder="Digite aqui"
        label="Anotações do dia"
        name="TxAnotacao"
        [(ngModel)]="form.TxAnotacao"
        [requiredInput]="true"
      ></app-input>
      <div class="img-input grid-2fr">
        <app-drag-drop
          label="Envio de fotos"
          text="Arraste para enviar as fotos"
          name="exameAdmissional"
          acceptedFileType=".jpg,image/jpeg"
          (fileDropped)="onFileDropped($event)"
          [requiredInput]="true"
          *ngIf="!isEditing"
        ></app-drag-drop>
        <h3 *ngIf="isEditing">Imagens do diário</h3>
        <div class="archive" *ngFor="let imagem of form.ImagensObra">
          <div class="archive-icon-name">
            <div class="archive-flex">
              <img src="assets/images/file.svg" />
              <p>{{ imagem.NmImagemObra }}</p>
            </div>
            <div class="archive-flex">
              <img
                class="archive-icon-click"
                src="assets/images/bxs-eye.svg"
                (click)="
                  visualizarDocumento(imagem.TxImagemObra, imagem.NmImagemObra)
                "
              />
              <img
                class="archive-icon-click"
                src="assets/images/bxs-download.svg"
                (click)="
                  downloadArquivo(imagem.TxImagemObra, imagem.NmImagemObra)
                "
              />
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="form-button">
      <app-botao
        width="100%"
        [text]="!isEditing ? 'Registrar diário' : 'Salvar alterações'"
        (click)="postForm()"
        [disabled]="validarForm()"
      ></app-botao>
    </div>
  </div>
</app-menu>

<app-modal-documento-layout
  *ngIf="visibleModalDocumento"
  [documentoData]="documentoModalData"
  (inputClose)="visualizarDocumento()"
></app-modal-documento-layout>
<app-loader *ngIf="loader" />
